import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import Features from "./pages/Features";
import HouseholdProfile from "./pages/HouseholdProfile";
import Meals from "./pages/Meals";
import Cooking from "./pages/Cooking";
import Pantry from "./pages/Pantry";
import Memory from "./pages/Memory";
import Learning from "./pages/Learning";
import University from "./pages/University";
import LittleChefs from "./pages/LittleChefs";
import Waitlist from "./pages/Waitlist";
import AdminWaitlist from "./pages/AdminWaitlist";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/features/household-profile" element={<HouseholdProfile />} />
          <Route path="/features/meal-recommendations" element={<Meals />} />
          <Route path="/features/guided-cooking" element={<Cooking />} />
          <Route path="/features/pantry-shopping" element={<Pantry />} />
          <Route path="/features/feedback-memory" element={<Memory />} />
          <Route path="/advanced-learning" element={<Learning />} />
          <Route path="/advanced-learning/honestgrow-university" element={<University />} />
          <Route path="/advanced-learning/little-chefs-academy" element={<LittleChefs />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/admin/waitlist" element={<AdminWaitlist />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
      <Toaster theme="dark" position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
